const EMAIL_BUILDER_PREVIEW_FRAME_STYLES = [
  "html,body{overflow:hidden!important;}",
  "a:hover{text-decoration:none!important;}",
].join("");

export function prepareEmailBuilderPreviewHtml(html: string): string {
  const withSafeLinks = html.replace(/<a\b([^>]*)>/gi, (_match, attrs: string) => {
    const withoutTargetOrRel = attrs
      .replace(/\s+target\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "")
      .replace(/\s+rel\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");

    return `<a${withoutTargetOrRel} target="_blank" rel="noopener noreferrer">`;
  });

  const previewFrameStyle = `<style>${EMAIL_BUILDER_PREVIEW_FRAME_STYLES}</style>`;
  if (/<\/head>/i.test(withSafeLinks)) {
    return withSafeLinks.replace(/<\/head>/i, `${previewFrameStyle}</head>`);
  }

  return previewFrameStyle + withSafeLinks;
}
